import React, { useState } from "react";
import { useGetOrderDocumentsQuery } from "../../queries";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import { Icon, Table, Title } from "../../../../components";
import { Column } from "react-data-grid";
import {
  getTableDataByPage,
  getTablePageCount,
  renderServiceObjects,
} from "../../../../helpers/tableHelpers";
import { MAIN_IMAGE_ROOT } from "../../../../app_config";
import { downloadURI } from "../../../../helpers/fileHelper";
import { CustomReportDocumentsTableQuery } from "../../../documents/models";
import { useNavigate } from "../../../../helpers/navigationHelpers";
import { renderDate } from "../../../../helpers/dayjsHeleprs";
import { CPCustomFormReportDocumentDetail } from "../../../../api/models/unified";

interface Props {
  orderId: string;
}

const defaultTableQuery: CustomReportDocumentsTableQuery = {
  page: 1,
  pageSize: 10,
};

const OrderCustomReportDocumentsTable: React.FC<Props> = (
  props,
): React.ReactElement => {
  const { orderId } = props;
  const { tOrder, tReport } = useCustomTranslation();
  const navigate = useNavigate();

  const [queryParams, setQueryParams] =
    useState<CustomReportDocumentsTableQuery>(defaultTableQuery);

  const query = useGetOrderDocumentsQuery(orderId);

  const columns: Column<CPCustomFormReportDocumentDetail>[] = [
    {
      key: "interventionDay",
      name: tReport("interventionDay"),
      renderCell: ({ row }) => renderDate(row.interventionDay),
    },
    {
      key: "name",
      name: tReport("name"),
    },
    {
      key: "serviceObjectNames",
      name: tReport("serviceObjects"),
      renderCell: ({ row }) => renderServiceObjects(row.serviceObjectNames),
    },
  ];

  return (
    <div className="mt-14">
      <Title className="mb-2.5 ml-5" title={tOrder("documents")} />
      <Table
        columns={columns}
        data={getTableDataByPage(queryParams, query.data?.documents ?? [])}
        loading={query.isLoading}
        queryParams={queryParams}
        onTableQueryChange={setQueryParams}
        pageCount={getTablePageCount(
          query.data?.documents?.length ?? 0,
          queryParams.pageSize,
        )}
        renderItemActions={(item) => (
          <div className="flex flex-row">
            <Icon
              name="eye"
              className="cursor-pointer"
              onClick={() => navigate.goTo(`documents/${item.id}`)}
            />
            <Icon
              name="print"
              className="mx-5 cursor-pointer"
              onClick={() => window.open(`${MAIN_IMAGE_ROOT}${item.publicUrl}`)}
            />
            <Icon
              name="file-download"
              className="cursor-pointer"
              onClick={() =>
                downloadURI(`${MAIN_IMAGE_ROOT}${item.publicUrl}`, item.name)
              }
            />
          </div>
        )}
        detailMode
      />
    </div>
  );
};

export default OrderCustomReportDocumentsTable;
